import createIcon from '../../createIcon';

/**
 * @component @name Campaign
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMTFWMTNIMjJWMTFIMThaTTE2IDE3LjYxQzE2Ljk2IDE4LjMyIDE4LjIxIDE5LjI2IDE5LjIgMjBDMTkuNiAxOS40NyAyMCAxOC45MyAyMC40IDE4LjRDMTkuNDEgMTcuNjYgMTguMTYgMTYuNzIgMTcuMiAxNkMxNi44IDE2LjU0IDE2LjQgMTcuMDggMTYgMTcuNjFaTTIwLjQgNS42QzIwIDUuMDcgMTkuNiA0LjUzIDE5LjIgNEMxOC4yMSA0Ljc0IDE2Ljk2IDUuNjggMTYgNi40QzE2LjQgNi45MyAxNi44IDcuNDcgMTcuMiA4QzE4LjE2IDcuMjggMTkuNDEgNi4zNSAyMC40IDUuNlpNNCA5QzIuOSA5IDIgOS45IDIgMTFWMTNDMiAxNC4xIDIuOSAxNSA0IDE1SDVWMTlIN1YxNUg4TDEzIDE4VjZMOCA5SDRaTTE1LjUgMTJDMTUuNSAxMC42NyAxNC45MiA5LjQ3IDE0IDguNjVWMTUuMzRDMTQuOTIgMTQuNTMgMTUuNSAxMy4zMyAxNS41IDEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Campaign = createIcon('Campaign', [
  [
    'path',
    {
      d: 'M18 11V13H22V11H18ZM16 17.61C16.96 18.32 18.21 19.26 19.2 20C19.6 19.47 20 18.93 20.4 18.4C19.41 17.66 18.16 16.72 17.2 16C16.8 16.54 16.4 17.08 16 17.61ZM20.4 5.6C20 5.07 19.6 4.53 19.2 4C18.21 4.74 16.96 5.68 16 6.4C16.4 6.93 16.8 7.47 17.2 8C18.16 7.28 19.41 6.35 20.4 5.6ZM4 9C2.9 9 2 9.9 2 11V13C2 14.1 2.9 15 4 15H5V19H7V15H8L13 18V6L8 9H4ZM15.5 12C15.5 10.67 14.92 9.47 14 8.65V15.34C14.92 14.53 15.5 13.33 15.5 12Z',
      key: '1ksufn',
    },
  ],
]);

export default Campaign;
